export function DateBodyTemplate(props) {
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };

  return new Date(props.value).toLocaleDateString(undefined, options);
}

export function FormLabel(props) {
  return (
    <label className="mb-1 block text-xs font-normal">{props.label}</label>
  );
}

export function FormErrorMessage(props) {
  return (
    props.errors[props.name] && (
      <small className="p-error">{props.errors[props.name].message}</small>
    )
  );
}
